class MobileNavigation extends HTMLElement {
  constructor() {
    super();

    document.documentElement.append(this);

    this.isOpen = false;
    this.locked = false;

    document.querySelector('.open-mobile-menu').addEventListener('click', (ev) => {
      this.isOpen ? this.close() : this.open();
    });

    this.querySelector('.close-mobile-menu').addEventListener('click', (ev) => {
      this.close();
    });

    this.addEventListener('custom:escape', (ev) => {
      this.close();
    });
    this.addEventListener('transitionstart', (ev) => (this.locked = true));
    this.addEventListener('transitionend', (ev) => (this.locked = false));

    // if someone clicks the newsletter link in the mobile footer
    document.querySelector('.open-mobile-newsletter')?.addEventListener('click', (ev) => {
      this.open();
      waitForTransitionEnd(this).then(() => {
        setTimeout(() => this.querySelector('[name="contact[email]"]').focus(), 64);
      });
    });
  }

  open() {
    if (this.locked) return;
    const currentScrollPosition = document.documentElement.scrollTop;
    if (currentScrollPosition > 0) {
      document.querySelector('shallow-clone')?.pauseScroll();
      window.cacheHeight(currentScrollPosition);
    }
    this.classList.remove('hidden');
    onceVisible(this).then(() => {
      this.classList.add('-lg:translate-x-0');
      waitForTransitionEnd(this).then(() => {
        trapFocus(this);
        this.isOpen = true;
        document.querySelectorAll('#main, #footer').forEach((elem) => {
          elem.classList.add('hidden');
          elem.setAttribute('aria-hidden', 'true');
        });
      });
    });
  }

  close() {
    if (this.locked) return;
    document.querySelectorAll('#main, #footer').forEach((elem) => {
      elem.classList.remove('hidden');
      elem.setAttribute('aria-hidden', 'false');
    });

    this.classList.remove('-lg:translate-x-0', 'absolute');
    this.classList.add('fixed');
    releaseFocus(this);
    this.isOpen = false;

    document.querySelector('.open-mobile-menu').focus();
    window.restoreHeight();
    waitForTransitionEnd(this).then(() => {
      this.classList.add('hidden', 'absolute');
      this.classList.remove('fixed');
    });
  }
}

customElements.define('mobile-navigation', MobileNavigation);
